export const transmissionToggleState = {
  isFilterToggled: false,
  isShowFilter: true,
  isFilterAlert: false,
  isHideBilledFilter: false,
  isMyPatientsFilter: null,
  transmissionType: "all",
  reportType: "all",
  priorityType: "all",
  showSavedReports: false,
  showAuditedReports: false,
};
